import { Button, Col, Container, Row } from "react-bootstrap"

function GetStarted() {
  return (
    <>
      <div className="mt-5 pt-sm-5">
        <Container fluid style={{ background: "#1E2538" }}>
          <Row className="justify-content-center">
            <Col col="12" className="py-5">
              <div className="text-center py-5">
                <h1 className="text-white get_started_text fw-semibold">Get started with <br />CareerSahi today.</h1>
                <Button style={{ letterSpacing: "0.6px" }} className="bg-white text-black mt-3 border-0 px-3 login_button py-2 fw-semibold">Log In / Sign Up (Soon)</Button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}
export default GetStarted